"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Audio = void 0;
var react_1 = __importDefault(require("react"));
var ElementTag_1 = __importDefault(require("../internal/ElementTag"));
var Audio = function (_a) {
    var _b = _a.as, as = _b === void 0 ? 'audio' : _b, _c = _a.controls, controls = _c === void 0 ? false : _c, src = _a.src, alt = _a.alt, track = _a.track, className = _a.className, rest = __rest(_a, ["as", "controls", "src", "alt", "track", "className"]);
    if (typeof src === 'string') {
        rest.src = src;
    }
    return (react_1["default"].createElement(ElementTag_1["default"], __assign({ as: as, className: ['audio', className], controls: controls }, rest),
        src instanceof Array && src.map(function (s, i) { return react_1["default"].createElement("source", __assign({ key: i }, s)); }),
        track && track.map(function (t, i) { return react_1["default"].createElement("track", __assign({ key: i }, t)); }),
        alt));
};
exports.Audio = Audio;
//# sourceMappingURL=Audio.js.map